import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { fetchSiteConfig, fetchPresale, fetchTokenomics, fetchContent, fetchSocialLinks, fetchDepositWallets, fetchAirdropConfig } from '../services/api';

const SiteDataContext = createContext(null);

export const SiteDataProvider = ({ children }) => {
  const [siteConfig, setSiteConfig] = useState(null);
  const [presale, setPresale] = useState(null);
  const [tokenomics, setTokenomics] = useState(null);
  const [content, setContent] = useState(null);
  const [socialLinks, setSocialLinks] = useState(null);
  const [depositWallets, setDepositWallets] = useState(null);
  const [airdropConfig, setAirdropConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadAll = useCallback(async () => {
    try {
      const [sc, ps, tk, ct, sl, dw, ac] = await Promise.all([
        fetchSiteConfig().catch(() => null),
        fetchPresale().catch(() => null),
        fetchTokenomics().catch(() => null),
        fetchContent().catch(() => null),
        fetchSocialLinks().catch(() => null),
        fetchDepositWallets().catch(() => null),
        fetchAirdropConfig().catch(() => null),
      ]);
      if (sc) setSiteConfig(sc);
      if (ps) setPresale(ps);
      if (tk) setTokenomics(tk);
      if (ct) setContent(ct);
      if (sl) setSocialLinks(sl);
      if (dw) setDepositWallets(dw);
      if (ac) setAirdropConfig(ac);
    } catch (e) {
      console.error('Failed to load site data', e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadAll();
  }, [loadAll]);

  const refresh = () => loadAll();

  return (
    <SiteDataContext.Provider value={{ siteConfig, presale, tokenomics, content, socialLinks, depositWallets, airdropConfig, loading, refresh }}>
      {children}
    </SiteDataContext.Provider>
  );
};

export const useSiteData = () => {
  const context = useContext(SiteDataContext);
  if (!context) throw new Error('useSiteData must be used within SiteDataProvider');
  return context;
};
